import type { HttpErrorResponse } from '@angular/common/http';
import type { FormGroup } from '@angular/forms';

export const setFormErrors = (form: FormGroup, error: HttpErrorResponse) => {
  const errors = error?.error?.errors;
  const controlNames = Object.keys(form.controls);
  if (!errors) {
    return;
  }
  controlNames.forEach((controlName) => {
    if (!(errors[controlName] instanceof Array)) {
      return;
    }

    const controlError = (errors[controlName] as Array<{ message: string }>)?.find(Boolean);

    if (controlError) {
      form.get(controlName)?.markAsDirty();
      form.get(controlName)?.markAsTouched();
      form.get(controlName)?.setErrors({ custom: controlError?.message });
      window.scroll(0, 0);
    }
  });
  scrollToFirstInvalidControl(form);
};

export const scrollToFirstInvalidControl = (form: FormGroup) => {
  for (const key of Object.keys(form.controls)) {
    const control = form.get(key);
    if (control && control.invalid) {
      const invalidControl = document.querySelector(`[formControlName="${key}"]`);
      if (invalidControl) {
        (invalidControl as HTMLElement).scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        (invalidControl as HTMLElement).focus();
      }
      break;
    }
  }
};
